import styled, { css } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';
import { DividerVariant } from './Divider';

export const DividerContainer = styled.div<{ variant: DividerVariant }>`
    display: flex;
    align-items: center;
    height: ${({ variant }) => (variant === 'horizontal' ? 'auto' : '100%')};
    flex-direction: ${({ variant }) => (variant === 'horizontal' ? 'row' : 'column')};
`;

export const DividerElement = styled.div<{ variant: DividerVariant }>`
    flex: 1 1;
    ${({ variant }) =>
        variant === 'horizontal'
            ? css`
                  border-top: ${getToken(TokenName.BORDER_WIDTH_150)}px ${getToken(TokenName.BORDER_STYLE_SOLID_STYLE)};
              `
            : css`
                  border-left: ${getToken(TokenName.BORDER_WIDTH_150)}px ${getToken(TokenName.BORDER_STYLE_SOLID_STYLE)};
              `}
    border-color: ${getToken(TokenName.BORDER_STATIC_SECONDARY)};
`;

export const DividerContent = styled.div`
    color: ${getToken(TokenName.TEXT_STATIC_SECONDARY)};
    ${getTextTokenPreset('BODY_S_STRONG')};
    padding: 0 ${getToken(TokenName.SPACING_150)}px;
`;
